/**
 * BrandSpaceUsageText
 *
 * "{used} of {total} Brand Spaces in use" (unlimited: "{used} Brand Spaces in use"), plus
 * "{paused} paused" when any brand is paused. Renders nothing when the usage is not available.
 */

import { useTranslation } from 'react-i18next';
import type { BrandSpaceUsage } from '@/types/package';

interface BrandSpaceUsageTextProps {
  usage: BrandSpaceUsage | null;
  className?: string;
}

export const BrandSpaceUsageText = ({ usage, className }: BrandSpaceUsageTextProps) => {
  const { t } = useTranslation('agency');
  if (!usage) return null;

  const main =
    usage.total === null
      ? t('brand_space_usage_unlimited', { used: usage.used })
      : t('brand_space_usage_of', { used: usage.used, total: usage.total });

  return (
    <span className={className}>
      {main}
      {usage.paused > 0 && (
        <>
          <span className="text-gray-300 mx-1" aria-hidden="true">·</span>
          {t('brand_space_usage_paused', { count: usage.paused })}
        </>
      )}
    </span>
  );
};

export default BrandSpaceUsageText;
